export default "__VITE_ASSET__YgkUVqHG__"